module.exports = __webpack_public_path__ + "img/KSC04613.51b25404.jpg";